export const FEED_SCROLL_POSITION_KEY = 'feed-scroll';
export const NOTIFICATION_SCROLL_POSITION_KEY = 'notif-scroll';
export const EXPLORE_SCROLL_POSITION_KEY = 'explore-scroll';
export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const ACCESS_TOKEN_KEY_CLIENT = 'access_token_client';
export const EXPIRE_IN_KEY_CLIENT = 'expires_in_client';
export const EXPIRE_IN_KEY = 'expires_in';
export const THEME = 'theme';
export const INVITE_CODE = 'UserInviteCode';
export const REQUESTED_AUTHOR_NAME = 'requested_author_name';
export const SEARCH_HISTORY = 'sh';
export const CLIENT_DATA = 'c-da';
export const TRANSFORM_PROFILE_DATA = 't-da';
export const CATEGORY_DATA = 'cat-da';

